import React from "react";
import "../Trend/Trend.css";

const Trend = () => {
    const items = [
        { id: 1, imgSrc: "trend1.webp", title: "Bonsai Collection - Up to 25% Off" },
        { id: 2, imgSrc: "trend2.webp", title: "Premium Ceramic Planters - Starting at ₹299" },
        { id: 3, imgSrc: "trend3.webp", title: "Kokedama Arrangements - From ₹249" },
        { id: 4, imgSrc: "trend4.webp", title: "Comprehensive Gardening Solutions - Up to 65% Off" },
      ];
      

  return (
    <section className="trend-section">
      <h2 className="trend-title">Trendings</h2>
      <div className="trend-grid">
        {items.map((item) => (
          <div key={item.id} className="trend-item">
            <img src={item.imgSrc} alt={item.title} className="trend-image" />
            <h4 className="trend-text">{item.title}</h4>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Trend;
